<template>
  <div class="login">
    <div class="container">
      <!-- <img class="logo" src="./logo.png" alt="" /> -->
      <div class="login-form">
        <!-- <h1>用数据洞察世界</h1> -->
        <div class="form-wrap">
          <h2>欢迎注册</h2>
          <a-form-model :model="form" :rules="rules" ref="form">
            <a-form-model-item prop="phoneMail">
              <a-input v-model="form.phoneMail" size="large" placeholder="请输入手机号或邮箱">
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="verificationCode">
              <a-input
                v-model="form.verificationCode"
                size="large"
                :placeholder="verificationPlaceholder"
              >
                <a-button
                  type="link"
                  @click="getVerifyCode"
                  :disabled="verificationDisabled"
                  slot="suffix"
                  :loading="codeLoading"
                  ><a-divider type="vertical" /> <span>获取验证码</span>
                </a-button>
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input
                v-model="form.password"
                size="large"
                type="password"
                placeholder="请输入密码"
              >
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="confimPassword">
              <a-input
                v-model="form.confimPassword"
                size="large"
                type="password"
                placeholder="请再次输入密码"
              >
              </a-input>
            </a-form-model-item>
            <div class="registe">
              <a-checkbox :checked="isSubmitContract" @click="submitContract"> </a-checkbox>
              <a @click="handleContract" style="margin-left: 10px">服务协议</a>
            </div>
            <a-form-model-item style="margin-bottom: 14px">
              <a-button
                @click="handleSubmit"
                size="large"
                style="width: 100%"
                type="primary"
                html-type="submit"
              >
                注 册
              </a-button>
            </a-form-model-item>
            <div class="log-in-now">
              <span>已有账号 <a href="#/login">立即登录</a></span>
            </div>
          </a-form-model>
        </div>
        <a-modal
          width="800px"
          title="服务协议"
          :visible="contractVisible"
          :closable="false"
          @ok="handleOk"
        >
          <template slot="footer">
            <a-button key="submit" type="primary" @click="handleOk"> 确定 </a-button>
          </template>

          <div class="contract">
            <p>
              {{ contract }}
            </p>
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { contract } from '@/common/Login/Contract'
import { getVerifyCodeApi, userRegisterApi, userIsExistApi } from '@/api/System/User'
const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
export default {
  data() {
    let validatePhoneMail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号或邮箱'))
      } else {
        if (phoneReg.test(value) || emailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号或邮箱格式'))
        }
      }
    }
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.confimPassword !== '') {
          this.$refs.form.validateField('confimPassword')
        }
        callback()
      }
    }
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次密码不相同'))
      } else {
        callback()
      }
    }
    return {
      form: {
        phoneMail: '',
        verificationCode: '',
        password: '',
        confimPassword: ''
      },
      verificationPlaceholder: '请输入验证码',
      rules: {
        phoneMail: [{ validator: validatePhoneMail, trigger: 'change' }],
        verificationCode: [{ required: true, message: '验证码不能为空', trigger: 'change' }],
        password: [{ validator: validatePass, trigger: 'change' }],
        confimPassword: [{ validator: validatePass2, trigger: 'change' }]
      },
      timer: null,
      count: '',
      verificationDisabled: false,
      contractVisible: false,
      contract: contract,
      codeLoading: false,
      isSubmitContract: false
    }
  },
  methods: {
    //获取验证码
    async getVerifyCode() {
      let { phoneMail } = this.form
      if (phoneReg.test(phoneMail) || emailReg.test(phoneMail)) {
        let type = ''
        if (phoneReg.test(phoneMail)) {
          type = 'sms'
        } else if (emailReg.test(phoneMail)) {
          type = 'mail'
        } else {
          type = ''
        }
        this.codeLoading = true
        let res = await getVerifyCodeApi({ loginAccount: phoneMail, needVerify: true, type })
        this.codeLoading = false
        let { code, msg } = res
        if (code == 200) {
          this.getPhoneCode()
        } else {
          this.$message.error(msg)
        }
      } else {
        this.$message.error('请填写正确的手机号或邮箱')
      }
    },

    getPhoneCode() {
      let TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
            this.verificationPlaceholder = this.count + 's后重新获取验证码'
            this.verificationDisabled = true
          } else {
            clearInterval(this.timer)
            this.timer = null
            this.verificationPlaceholder = '请输入验证码'
            this.verificationDisabled = false
          }
        }, 1000)
      }
    },
    async handleLoginAccountIsExist(callback) {
      let res = await userIsExistApi({ loginAccount: this.form.phoneMail })
      let { extra, code, msg } = res
      callback(new Error('co'))
    },

    async handleRegister() {
      let { password, phoneMail, verificationCode } = this.form
      let postData = {
        mail: '',
        phone: '',
        password,
        userName: phoneMail,
        verifyCode: verificationCode
      }
      if (phoneReg.test(phoneMail)) {
        postData.phone = phoneMail
      } else if (emailReg.test(phoneMail)) {
        postData.mail = phoneMail
      }
      let res = await userRegisterApi({ ...postData })
      let { code, msg } = res
      if (code == 200) {
        this.$message.success(msg)
        this.$router.push({ name: 'login' })
      } else {
        this.$message.error(msg)
      }
    },

    submitContract(e) {
      this.isSubmitContract = !this.isSubmitContract
    },
    handleContract() {
      this.contractVisible = true
    },
    handleOk() {
      this.contractVisible = false
    },
    handleSubmit() {
      if (!this.isSubmitContract) {
        this.$message.error('请同意服务协议')
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.handleRegister()
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  background: url('./login.png');
  background-size: 100%;
  position: relative;
  .container {
    // background: url('./bg-container.png');
    background-size: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1200px;
    height: 500px;
    .logo {
      position: absolute;
      left: 170px;
      top: -100px;
      width: 160px;
      height: 60px;
    }
    .login-form {
      width: 420px;
      box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 00px;
      right: 31%;
      box-sizing: border-box;
      h1 {
        height: 55px;
        font-size: 40px;
        font-weight: 500;
        color: #fff;
        margin-bottom: 45px;
        text-align: center;
        letter-spacing: 2px;
      }
      .form-wrap {
        background: #ffffff;
        padding: 20px 40px 25px;
        border-radius: 6px;

        .service-contract {
          font-size: 12px;
          color: #999999;
          line-height: 18px;
          text-align-last: center;
        }

        h2 {
          font-size: 26px;
          color: #3c93ff;
          margin-bottom: 20px;
          text-align: center;
        }
        .registe {
          margin-bottom: 20px;
        }
        .log-in-now {
          text-align: center;
          a {
            color: #3c93ff;
          }
        }
      }
      .code-btn {
        font-style: normal;
        color: #3c93ff;
        cursor: pointer;
      }
    }
  }
}

.contract {
  white-space: pre-line;
}
</style>
